var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#206CFF"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"3","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }